var formPrepare = function (form) {
  $(form)
    .find("textarea")
    .each(function () {
      autosize($(this));
    });

  $(form)
    .find("input[type=checkbox]")
    .each(function () {
      if (!$(this).prop("checked")) return;
      $(this).closest(".form-group").find("label").addClass("checked");
    });

  $(form)
    .find("input[type=checkbox]")
    .on("click", function () {
      if (!$(this).prop("checked")) {
        $(this).closest(".form-group").find("label").removeClass("checked");
        return;
      }

      $(this).closest(".form-group").find("label").addClass("checked");
    });

  $(form)
    .find(".mask-email")
    .mask("A", {
      translation: {
        A: { pattern: /[\w@\-.+]/, recursive: true },
      },
      // onInvalid: function(val, e, f, invalid, options){
      // var error = invalid[0];
      // console.log ("Digit: ", error.v, " is invalid for the position: ", error.p, ". We expect something like: ", error.e);
      // }
    });

  $(form).find(".mask-phone").mask("+7 000 000 00 00");

  // $(form).find('button[type=submit]').on('click', function(event) {
  // event.preventDefault();
  // formSubmit(form);
  // });
};

var formValidate = function (form) {
  var params = {};
  var formVar = $(form).serializeArray();
  var valid = true;

  $(form).find(".warning").removeClass("warning");

  $.each(formVar, function (i, v) {
    $(form)
      .find('.required [name="' + v.name + '"]')
      .each(function () {
        if ($(this).parent().hasClass("form-check")) {
          if ($(this).attr("type") != "checkbox" || $(this).prop("checked"))
            return;

          $(this).parent().addClass("warning");
          valid = false;

          return;
        }

        if (v.value) return;

        $(this).addClass("warning");
        valid = false;
      });

    params[v.name] = v.value;
  });

  return Boolean(valid);
};

var emailValidate = function (email) {
  let re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return re.test(email);
};

var responseError = function () {
  $("#modal").modal("show");

  $("#modal .modal-body").empty();
  $("#modal .modal-body").append(
    $("<h3/>", {
      html: "Что-то пошло не так :(",
    })
  );

  buttonReset($("button.loading"), false);
};

var responseCheck = function (response) {
  if (response["redirect"]) {
    location = response["redirect"];
    return false;
  }

  if (!response["error"]) {
    return true;
  }

  responseError();

  for (var [key, value] of Object.entries(response.error)) {
    if (key == "captcha") {
      grecaptcha.reset();
    }

    $("form [name=" + key + "]").addClass("warning");

    $("#modal .modal-body").append(
      $("<p/>", {
        html: value,
      })
    );
  }

  return false;
};

function showFormSample(id, image) {
  $("#modal").modal("show");

  var $form = $(`<form id="form-sample" class="form-sample" />`).append(
    $(`<input type="hidden" name="product_id" value="${id}" />`),
    $(`<div class="form-group required" />`).append(
      $(
        `<input id="input-firstname" class="form-control" name="firstname" autocomplete="off" />`
      ),
      $(`<label for="input-firstname">Имя</label>`)
    ),
    $(`<div class="form-group required" />`).append(
      $(
        `<input id="input-telephone" class="form-control" name="telephone" autocomplete="off" />`
      ),
      $(`<label for="input-telephone">Телефон или эл. почта</label>`)
    ),
    $(`<div class="form-group " />`).append(
      $(
        `<button id="button-sample" class="btn btn_100 btn-harsika" type="button" onclick="submitFormSample()">Отправить</button>`
      ),
      $(
        `<p class="p3">Нажимая на кнопку, вы даёте согласие на обработку своих персональных данных.</p>`
      )
    )
  );

  $("#modal .modal-body")
    .empty()
    .append(
      $("<h3/>", {
        html: "Я хочу заказать образец",
      }),
      $(`<img src="${image}" />`),
      $form
    );
}

function submitFormSample() {
  var $form = $("#form-sample"),
    $button = $("#button-sample");

  if (!formValidate($form)) return;

  buttonLoad($button);

  $.post("index.php?route=rmx/contacts/sample", $form.serialize())
    .fail(() => buttonReset($button, false))
    .done((response) => {
      if (response["error"]) {
        buttonReset($button, false);
      } else {
        $("#modal").modal("hide");
        buttonReset($button);
      }
    });
}
